import { useTranslation, withTranslation } from 'react-i18next';
import React from 'react';
import './index.scss';

const PriceDisclaimer = ({ disclaimerType }) => {
  const { t } = useTranslation();
  return (
    <div className="priceDisclaimerWrapper">
      {disclaimerType === 'Chart' && (
        <p className="priceDisclaimerText mb-40">{t('PriceChartDisclaimer')}</p>
      )}
      {disclaimerType === 'Table' && (
        <p className="priceDisclaimerText">{t('PriceTableDisclaimer')}</p>
      )}
    </div>
  );
};

PriceDisclaimer.propTypes = {
  disclaimerType: 'Chart' | 'Table'
};

PriceDisclaimer.defaultProps = {
  disclaimerType: ''
};

export default withTranslation()(PriceDisclaimer);
